var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _g, _rect2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoogleplay(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 43,
    viewBox: "0 0 140 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.81037,
    y: 0.396552,
    width: 138.793,
    height: 41.2414,
    rx: 3.56897,
    fill: "#0A0A0A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M70.8637 22.8573C68.4318 22.8573 66.4497 24.7373 66.4497 27.3266C66.4497 29.9002 68.4318 31.796 70.8637 31.796C73.2966 31.796 75.2787 29.9002 75.2787 27.3266C75.2777 24.7373 73.2956 22.8573 70.8637 22.8573ZM70.8637 30.0368C69.5309 30.0368 68.3822 28.9198 68.3822 27.3277C68.3822 25.7188 69.5319 24.6186 70.8637 24.6186C72.1965 24.6186 73.3452 25.7188 73.3452 27.3277C73.3452 28.9187 72.1965 30.0368 70.8637 30.0368ZM61.2333 22.8573C58.8014 22.8573 56.8192 24.7373 56.8192 27.3266C56.8192 29.9002 58.8014 31.796 61.2333 31.796C63.6662 31.796 65.6483 29.9002 65.6483 27.3266C65.6483 24.7373 63.6662 22.8573 61.2333 22.8573ZM61.2333 30.0368C59.9005 30.0368 58.7517 28.9198 58.7517 27.3277C58.7517 25.7188 59.9015 24.6186 61.2333 24.6186C62.5661 24.6186 63.7148 25.7188 63.7148 27.3277C63.7158 28.9187 62.5661 30.0368 61.2333 30.0368ZM49.7789 24.2297V26.1255H54.2436C54.1102 27.1921 53.7608 27.9708 53.2272 28.512C52.5779 29.172 51.5615 29.9002 49.7789 29.9002C47.0306 29.9002 44.882 27.6482 44.882 24.855C44.882 22.0618 47.0306 19.8098 49.7789 19.8098C51.2616 19.8098 52.3442 20.4025 53.1435 21.1644L54.4597 19.8266C53.343 18.7432 51.8613 17.9141 49.7789 17.9141C46.0142 17.9141 42.8492 21.0288 42.8492 24.855C42.8492 28.6812 46.0142 31.796 49.7789 31.796C51.8107 31.796 53.3441 31.1182 54.5424 29.8487C55.7749 28.5961 56.1585 26.8348 56.1585 25.413C56.1585 24.9738 56.1254 24.5671 56.0582 24.2287H49.7789V24.2297ZM96.6261 25.702C96.2601 24.7037 95.1434 22.8573 92.8615 22.8573C90.596 22.8573 88.7132 24.669 88.7132 27.3266C88.7132 29.8319 90.5795 31.796 93.0775 31.796C95.0928 31.796 96.2591 30.5433 96.743 29.8151L95.2437 28.7989C94.7443 29.544 94.0609 30.0347 93.0775 30.0347C92.0953 30.0347 91.3953 29.5776 90.9455 28.6802L96.8257 26.2085L96.6261 25.702ZM90.6291 27.1921C90.5795 25.4645 91.9453 24.5849 92.9287 24.5849C93.6948 24.5849 94.3442 24.9748 94.5613 25.5328L90.6291 27.1921ZM85.849 31.5259H87.7805V18.3891H85.849V31.5259ZM82.683 23.8567H82.6168C82.1836 23.3313 81.3502 22.8573 80.3018 22.8573C78.1025 22.8573 76.0873 24.8214 76.0873 27.3445C76.0873 29.8498 78.1025 31.797 80.3018 31.797C81.3513 31.797 82.1836 31.3231 82.6168 30.7819H82.683V31.425C82.683 33.1348 81.7835 34.049 80.3349 34.049C79.152 34.049 78.4189 33.1863 78.1191 32.458L76.4368 33.1694C76.9197 34.3538 78.2018 35.8103 80.3349 35.8103C82.6003 35.8103 84.5163 34.4557 84.5163 31.1539V23.1295H82.6841V23.8567H82.683ZM80.4683 30.0368C79.1355 30.0368 78.0198 28.9019 78.0198 27.3445C78.0198 25.7693 79.1355 24.6186 80.4683 24.6186C81.7835 24.6186 82.8164 25.7693 82.8164 27.3445C82.8164 28.9019 81.7835 30.0368 80.4683 30.0368ZM105.678 18.3891H101.055V31.5259H102.983V26.549H105.676C107.815 26.549 109.918 24.9759 109.918 22.4696C109.918 19.9632 107.816 18.3891 105.678 18.3891ZM105.727 24.7205H102.983V20.2176H105.727C107.17 20.2176 107.988 21.4313 107.988 22.4696C107.988 23.4868 107.17 24.7205 105.727 24.7205ZM117.651 22.8342C116.254 22.8342 114.808 23.4595 114.209 24.8456L115.921 25.5717C116.287 24.8456 116.97 24.6081 117.684 24.6081C118.682 24.6081 119.696 25.2165 119.713 26.2978V26.4334C119.363 26.2306 118.615 25.9269 117.701 25.9269C115.855 25.9269 113.975 26.9578 113.975 28.884C113.975 30.6421 115.489 31.7739 117.185 31.7739C118.481 31.7739 119.197 31.1823 119.645 30.4887H119.712V31.5028H121.575V26.466C121.576 24.1352 119.862 22.8342 117.651 22.8342ZM117.417 30.0337C116.787 30.0337 115.905 29.7121 115.905 28.9176C115.905 27.9036 117.003 27.5147 117.951 27.5147C118.798 27.5147 119.198 27.7008 119.713 27.954C119.563 29.172 118.532 30.0337 117.417 30.0337ZM128.36 23.1211L126.148 28.8168H126.082L123.787 23.1211H121.708L125.15 31.0814L123.188 35.5097H125.2L130.505 23.1211H128.36ZM110.983 31.5259H112.911V18.3891H110.983V31.5259Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M49.442 10.7641C49.442 11.6447 49.1856 12.3457 48.6717 12.869C48.0885 13.4911 47.3275 13.8022 46.3928 13.8022C45.4974 13.8022 44.7354 13.4869 44.1098 12.8564C43.4832 12.2248 43.1699 11.443 43.1699 10.5098C43.1699 9.57559 43.4832 8.79375 44.1098 8.16323C44.7354 7.53167 45.4974 7.21641 46.3928 7.21641C46.8374 7.21641 47.2624 7.30468 47.6656 7.48017C48.0699 7.65672 48.3935 7.89106 48.6355 8.18425L48.0906 8.73911C47.6801 8.23995 47.1145 7.99089 46.3918 7.99089C45.7383 7.99089 45.1738 8.22419 44.6971 8.69077C44.2204 9.15735 43.9826 9.7637 43.9826 10.5088C43.9826 11.2538 44.2204 11.8602 44.6971 12.3268C45.1738 12.7933 45.7383 13.0266 46.3918 13.0266C47.0845 13.0266 47.6625 12.7923 48.1247 12.3225C48.4246 12.0167 48.5983 11.5911 48.6448 11.0457H46.3918V10.2881H49.3975C49.4286 10.4531 49.442 10.6117 49.442 10.7641Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M54.2087 8.13072H51.3839V10.1295H53.9316V10.8871H51.3839V12.8859H54.2087V13.6614H50.5867V7.35623H54.2087V8.13072Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M57.57 13.6614H56.7728V8.13072H55.0399V7.35623H59.303V8.13072H57.57V13.6614Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M62.3873 13.6614V7.35623H63.1845V13.6614H62.3873Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M66.7198 13.6614H65.9226V8.13072H64.1896V7.35623H68.4527V8.13072H66.7198V13.6614Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M76.5226 12.847C75.9126 13.4838 75.1547 13.8022 74.2479 13.8022C73.3411 13.8022 72.5832 13.4838 71.9742 12.847C71.3641 12.2102 71.0602 11.4304 71.0602 10.5088C71.0602 9.5872 71.3641 8.80746 71.9742 8.17064C72.5832 7.53382 73.3411 7.21436 74.2479 7.21436C75.1495 7.21436 75.9064 7.53487 76.5185 8.17484C77.1306 8.81482 77.4367 9.59246 77.4367 10.5088C77.4367 11.4304 77.1316 12.2102 76.5226 12.847ZM72.5625 12.3184C73.0216 12.7913 73.583 13.0267 74.2479 13.0267C74.9127 13.0267 75.4752 12.7902 75.9333 12.3184C76.3924 11.8455 76.6229 11.2423 76.6229 10.5088C76.6229 9.77531 76.3924 9.17211 75.9333 8.69922C75.4752 8.22634 74.9127 7.99094 74.2479 7.99094C73.583 7.99094 73.0216 8.22739 72.5625 8.69922C72.1045 9.17211 71.8739 9.77531 71.8739 10.5088C71.8739 11.2423 72.1045 11.8455 72.5625 12.3184Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M78.5554 13.6614V7.35623H79.5253L82.5404 12.2606H82.5745L82.5404 11.0458V7.35623H83.3376V13.6614H82.5052L79.3506 8.51849H79.3164L79.3506 9.73328V13.6614H78.5554Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M49.442 10.7641C49.442 11.6447 49.1856 12.3457 48.6717 12.869C48.0885 13.4911 47.3275 13.8022 46.3928 13.8022C45.4974 13.8022 44.7354 13.4869 44.1098 12.8564C43.4832 12.2248 43.1699 11.443 43.1699 10.5098C43.1699 9.57559 43.4832 8.79375 44.1098 8.16323C44.7354 7.53167 45.4974 7.21641 46.3928 7.21641C46.8374 7.21641 47.2624 7.30468 47.6656 7.48017C48.0699 7.65672 48.3935 7.89106 48.6355 8.18425L48.0906 8.73911C47.6801 8.23995 47.1145 7.99089 46.3918 7.99089C45.7383 7.99089 45.1738 8.22419 44.6971 8.69077C44.2204 9.15735 43.9826 9.7637 43.9826 10.5088C43.9826 11.2538 44.2204 11.8602 44.6971 12.3268C45.1738 12.7933 45.7383 13.0266 46.3918 13.0266C47.0845 13.0266 47.6625 12.7923 48.1247 12.3225C48.4246 12.0167 48.5983 11.5911 48.6448 11.0457H46.3918V10.2881H49.3975C49.4286 10.4531 49.442 10.6117 49.442 10.7641Z",
    stroke: "white",
    strokeWidth: 0.158621,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M54.2087 8.13072H51.3839V10.1295H53.9316V10.8871H51.3839V12.8859H54.2087V13.6614H50.5867V7.35623H54.2087V8.13072Z",
    stroke: "white",
    strokeWidth: 0.158621,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M57.57 13.6614H56.7728V8.13072H55.0399V7.35623H59.303V8.13072H57.57V13.6614Z",
    stroke: "white",
    strokeWidth: 0.158621,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M62.3873 13.6614V7.35623H63.1845V13.6614H62.3873Z",
    stroke: "white",
    strokeWidth: 0.158621,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M66.7198 13.6614H65.9226V8.13072H64.1896V7.35623H68.4527V8.13072H66.7198V13.6614Z",
    stroke: "white",
    strokeWidth: 0.158621,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M76.5226 12.847C75.9126 13.4838 75.1547 13.8022 74.2479 13.8022C73.3411 13.8022 72.5832 13.4838 71.9742 12.847C71.3641 12.2102 71.0602 11.4304 71.0602 10.5088C71.0602 9.5872 71.3641 8.80746 71.9742 8.17064C72.5832 7.53382 73.3411 7.21436 74.2479 7.21436C75.1495 7.21436 75.9064 7.53487 76.5185 8.17484C77.1306 8.81482 77.4367 9.59246 77.4367 10.5088C77.4367 11.4304 77.1316 12.2102 76.5226 12.847ZM72.5625 12.3184C73.0216 12.7913 73.583 13.0267 74.2479 13.0267C74.9127 13.0267 75.4752 12.7902 75.9333 12.3184C76.3924 11.8455 76.6229 11.2423 76.6229 10.5088C76.6229 9.77531 76.3924 9.17211 75.9333 8.69922C75.4752 8.22634 74.9127 7.99094 74.2479 7.99094C73.583 7.99094 73.0216 8.22739 72.5625 8.69922C72.1045 9.17211 71.8739 9.77531 71.8739 10.5088C71.8739 11.2423 72.1045 11.8455 72.5625 12.3184Z",
    stroke: "white",
    strokeWidth: 0.158621,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M78.5554 13.6614V7.35623H79.5253L82.5404 12.2606H82.5745L82.5404 11.0458V7.35623H83.3376V13.6614H82.5052L79.3506 8.51849H79.3164L79.3506 9.73328V13.6614H78.5554Z",
    stroke: "white",
    strokeWidth: 0.158621,
    strokeMiterlimit: 10
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ii_2313_12271)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.2033 7.92193C10.9025 8.24559 10.7246 8.74791 10.7246 9.39839V32.6393C10.7246 33.2908 10.9025 33.7921 11.2033 34.1157L11.2799 34.1914L24.0897 21.1723V21.0188V20.8654L11.2799 7.84522L11.2033 7.92193Z",
    fill: "url(#paint0_linear_2313_12271)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.3589 25.5129L24.0896 21.1718V21.0184V20.865L28.3599 16.5249L28.4561 16.5806L33.5153 19.502C34.9598 20.3364 34.9598 21.7014 33.5153 22.5369L28.4561 25.4583L28.3589 25.5129Z",
    fill: "url(#paint1_linear_2313_12271)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_2313_12271)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.4561 25.4574L24.0886 21.0186L11.2032 34.1154C11.6789 34.6283 12.4657 34.6913 13.3518 34.1806L28.4561 25.4574Z",
    fill: "url(#paint2_linear_2313_12271)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M28.4561 16.5797L13.3518 7.85756C12.4657 7.34579 11.6789 7.4099 11.2032 7.92272L24.0896 21.0196L28.4561 16.5797Z",
    fill: "url(#paint3_linear_2313_12271)"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.81037,
    y: 0.396552,
    width: 138.793,
    height: 41.2414,
    rx: 3.56897,
    stroke: "#A6A6A6",
    strokeWidth: 0.793103
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ii_2313_12271",
    x: 10.7246,
    y: 7.50439,
    width: 23.874,
    height: 27.0288,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.118966
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2313_12271"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.118966
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_2313_12271",
    result: "effect2_innerShadow_2313_12271"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_2313_12271",
    x: 11.2032,
    y: 21.0186,
    width: 17.2528,
    height: 13.5146,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.118966
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2313_12271"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2313_12271",
    x1: 22.9542,
    y1: 9.15249,
    x2: 5.32095,
    y2: 26.5023,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0066,
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2601,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5122,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7604,
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2313_12271",
    x1: 35.3956,
    y1: 21.0184,
    x2: 10.3777,
    y2: 21.0184,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4087,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    stopColor: "#FFA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2313_12271",
    x1: 26.0843,
    y1: 23.4291,
    x2: 2.17138,
    y2: 46.9577,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2313_12271",
    x1: 7.95802,
    y1: 0.186059,
    x2: 18.6358,
    y2: 10.6922,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0685,
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4762,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8009,
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleplay);
export default __webpack_public_path__ + "static/media/googleplay.03948b3f56917a872c5eb497ac2d17c3.svg";
export { ForwardRef as ReactComponent };